import { Box, Flex, Text } from "@radix-ui/themes";
import ProductPlaceholderIcon from "@/assets/icons/product-placeholder.svg?react";
import { twMerge } from "tailwind-merge";

interface ProductItem {
  name: string | null;
  imageUrl: string | null;
  barcode: string | null;
  skuId: string | number | null;
  unitOfMeasurement?: string | null;
  quantity?: string | number | null;
  isQuantityNegative?: boolean;
  isQuantityDifferent?: boolean;
}

const ProductItem = ({
  name,
  imageUrl,
  barcode,
  skuId,
  quantity,
  unitOfMeasurement = "UoM",
  isQuantityNegative = false,
  isQuantityDifferent = false,
}: ProductItem) => {
  return (
    <Flex gap="2">
      {imageUrl ? (
        <img
          className="min-w-20 w-20 h-20 object-contain"
          src={imageUrl}
          alt={name || ""}
        />
      ) : (
        <Flex
          className="min-w-20 w-20 h-20 object-contain"
          align="center"
          justify="center"
        >
          <ProductPlaceholderIcon width={32} />
        </Flex>
      )}

      <Box>
        <Text
          size="1"
          as="p"
          weight="medium"
          className="text-ellipsis overflow-hidden line-clamp-2"
        >
          {name}
        </Text>
        <Text color="gray" size="1" as="p">
          Barcode: {barcode}
        </Text>
        <Text color="gray" size="1" as="p">
          SKU ID: {skuId}
        </Text>
        {quantity ? (
          <Text
            color="gray"
            size="1"
            as="p"
            className={twMerge(
              isQuantityNegative && "bg-red-200 px-1 rounded",
              isQuantityDifferent && "bg-red-200 px-1 rounded"
            )}
          >
            Quantity: {quantity} {unitOfMeasurement}
          </Text>
        ) : null}
      </Box>
    </Flex>
  );
};

export default ProductItem;
